/* Dela Studio — dela-ui.js
   Supplerer theme.js. Rører ikke kurv, varianter eller formularer. */
(function () {
  'use strict';

  var stille = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- den store sætning: snitlinje og tekst én gang, når den ses */
  function initReveal() {
    var el = document.querySelectorAll('[data-ds-reveal]:not(.ds-anim)');
    if (!el.length || stille || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.35 });
    Array.prototype.forEach.call(el, function (s) {
      /* allerede synlig ved indlæsning: vis den færdig, uden at blinke */
      var r = s.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return;
      s.classList.add('ds-anim');
      io.observe(s);
    });
  }

  /* ---------- beløbet i kurveknappen følger antallet */
  function penge(cents) {
    if (window.dsMoney) return window.dsMoney(cents);
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }
  function initCartTotal() {
    var sum = document.querySelector('[data-ds-cart-total]');
    var tal = document.querySelector('.ds-hdr [data-cart-count]');
    if (!sum || !tal || !window.MutationObserver) return;
    var rod = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    new MutationObserver(function () {
      fetch(rod + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { sum.textContent = penge(c.total_price); })
        .catch(function () {});
    }).observe(tal, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- deling: kopiér link, og Instagram via telefonens delingsmenu */
  function initShare() {
    var mobil = window.matchMedia('(pointer: coarse)').matches;
    if (navigator.share && mobil) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ds-share]'), function (b) {
        b.hidden = false;
      });
    }
    document.addEventListener('click', function (e) {
      var del = e.target.closest('[data-ds-share]');
      if (del && navigator.share) {
        navigator.share({ title: del.getAttribute('data-ds-share-title') || document.title, url: del.getAttribute('data-ds-share') }).catch(function () {});
        return;
      }
      var b = e.target.closest('[data-ds-copy]');
      if (!b || !navigator.clipboard) return;
      var tekst = b.textContent;
      navigator.clipboard.writeText(b.getAttribute('data-ds-copy')).then(function () {
        b.textContent = 'Linket er kopieret';
        setTimeout(function () { b.textContent = tekst; }, 2200);
      }).catch(function () {});
    });
  }

  /* ---------- bestillingssiden: emnet fra ?vare= følger med forespørgslen */
  function initVare() {
    var boks = document.querySelector('[data-ds-vare]');
    if (!boks) return;
    var vare = new URLSearchParams(window.location.search).get('vare');
    if (!vare) return;
    vare = vare.slice(0, 120);
    boks.querySelector('[data-ds-vare-input]').value = vare;
    boks.querySelector('[data-ds-vare-navn]').textContent = vare;
    boks.hidden = false;
  }

  /* ---------- bestillingssiden: filer fra Upload-Lift kommer med i mailen.
     Shopifys kontaktmail viser kun felter, der hedder contact[…]. Felter fra
     uploadappen, der hedder properties[…], omdøbes, og alle fillinks i
     uploadfeltet samles i contact[Filer], så de står som klikbare links. */
  function samlFiler(f) {
    var ud = f.querySelector('[data-ds-filer]');
    if (!ud) return;
    var kendte = {};
    f.querySelectorAll('input[name^="contact["]').forEach(function (i) {
      if (i !== ud && i.value) kendte[i.value] = true;
    });
    f.querySelectorAll('input[name^="properties["]').forEach(function (i) {
      i.name = 'contact[' + i.name.slice(11);
      if (i.value) kendte[i.value] = true;
    });
    var links = [];
    function tag(u) {
      u = String(u || '').trim();
      if (!/^https?:\/\//.test(u) || kendte[u] || links.indexOf(u) !== -1) return;
      links.push(u);
    }
    var felt = f.querySelector('.upload-lift') || f;
    felt.querySelectorAll('input').forEach(function (i) {
      String(i.value || '').split(/[\s,]+/).forEach(tag);
    });
    felt.querySelectorAll('a[href]').forEach(function (a) { tag(a.href); });
    ud.value = links.join('\n');
  }

  /* ---------- bestillingssiden: tomme valgfri felter kommer ikke med i mailen */
  function initRyd() {
    document.querySelectorAll('form#specialopgave').forEach(function (f) {
      f.addEventListener('submit', function () {
        samlFiler(f);
        f.querySelectorAll('[data-ds-valgfri]').forEach(function (el) {
          if (!String(el.value || '').trim()) el.disabled = true;
        });
        /* går man tilbage i browseren, skal felterne virke igen */
        setTimeout(function () {
          f.querySelectorAll('[data-ds-valgfri]').forEach(function (el) { el.disabled = false; });
        }, 1500);
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initReveal(); initCartTotal(); initShare(); initVare(); initRyd(); });
  document.addEventListener('shopify:section:load', initReveal);
})();
